/**
 * Two worlds that alternate: hopeful SOLARPUNK build stages and NEON
 * dystopia defend stages where the bad AI drains your energy.
 */

export const SOLARPUNK = {
  name: "SOLARPUNK",
  skyTop: 0x7fd8ff,
  skyBottom: 0xd8f7ff,
  sun: 0xffd84a,
  girder: 0x8b5e3c,
  girderTrim: 0x7bc74a,
  ladder: 0xd4a574,
  ladderGhost: 0x6b4423,
  water: 0x2f8fe8,
  turbine: 0xffffff,
  turbineHub: 0x7bc74a,
  barrel: 0x6a5acd,
  barrelBand: 0x3a2f8a,
  boss: 0x555566,
  bossEye: 0xff3355,
  text: "#1A3A12",
  accent: "#2E7D1E",
  hudBg: 0x0d2a10,
};

export const NEON = {
  name: "NEON DYSTOPIA",
  skyTop: 0x0a0014,
  skyBottom: 0x1a0030,
  sun: 0xff00ff,
  girder: 0x220033,
  girderTrim: 0xff00ff,
  ladder: 0x00ffff,
  ladderGhost: 0x005566,
  water: 0x39ff14,
  turbine: 0x00ffff,
  turbineHub: 0xff00ff,
  barrel: 0xff6600,
  barrelBand: 0x993300,
  boss: 0x333344,
  bossEye: 0xff0000,
  leech: 0x39ff14,
  spark: 0xffff33,
  text: "#FFFFFF",
  accent: "#00FFFF",
  hudBg: 0x000000,
};

export const paletteFor = (kind) => (kind === "build" ? SOLARPUNK : NEON);
